import React, { useState, useRef, useEffect } from "react";

const AuctionResults = ({ totalResults, onSortChange }) => {
  const [showSortDropdown, setShowSortDropdown] = useState(false);
  const [selectedSort, setSelectedSort] = useState("Sort By");

  const sortRef = useRef(null);

  // Handle click outside to close dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (sortRef.current && !sortRef.current.contains(event.target)) {
        setShowSortDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);



 

  return (
    <div className="bg-blue-900 max-w-[1080px] mx-auto my-4 text-white p-4 rounded-lg flex justify-between items-center">
      <span className="text-lg font-semibold">({totalResults}) results | Bank Auction</span>

      <div className="flex space-x-4">
        {/* Sort Filter */}
        <div className="relative" ref={sortRef}>
          <button
            onClick={() => setShowSortDropdown(!showSortDropdown)}
            className="bg-gray-100 text-blue-900 font-medium px-6 py-2 rounded-lg transition-all duration-300 hover:bg-gray-200 focus:ring focus:ring-gray-300"
          >
            {selectedSort}
          </button>
          {showSortDropdown && (
            <div className="absolute top-full right-0 mt-2 bg-white text-blue-900 rounded-lg shadow-lg w-48">
              <ul className="py-2">
                {["Sort By","Price: High to Low", "Price: Low to High"].map((option, index) => (
                  <li
                    key={index}
                    className={`px-4 py-2 cursor-pointer transition-all duration-300 ${
                      selectedSort === option ? "bg-blue-100 text-blue-800 font-semibold" : "hover:bg-gray-100"
                    }`}
                    onClick={() => {
                      setSelectedSort(option);
                      onSortChange(option === "Sort By" ? "" : option === "Price: High to Low" ? "highToLow" : "lowToHigh");
                      setShowSortDropdown(false);
                    }}
                  >
                    {option}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuctionResults;
